import React, {useState} from 'react';

export const context = React.createContext();

export default function Context ({children}){
	const [showItem, setShowItem] = useState('home')
	const [id, setId] = useState()

  	return (
	    
	    <context.Provider value={{showItem, setShowItem,id, setId}}>

	    	{children}
	    	
		</context.Provider>

  	)
 }
